import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FeiraClienteDto } from '../../dto/feira-cliente.dto';
import { FeiraClienteService } from '../../services/feira-cliente.service';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-modal-atualizar-feira-cliente',
  templateUrl: './modal-atualizar-feira-cliente.component.html',
  styleUrl: './modal-atualizar-feira-cliente.component.scss'
})
export class ModalAtualizarFeiraClienteComponent implements OnInit {
  @Input() feiraClienteDto!: FeiraClienteDto;
  feiraCliente!: FeiraClienteDto;
  feiraClienteForm!: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private feiraClienteService: FeiraClienteService,
    private toastService: ToastService,
    private route: Router,
    private fb: FormBuilder) { }

  ngOnInit(): void {

    this.feiraCliente = this.feiraClienteDto;

    this.feiraClienteForm = this.fb.group({
      metros: [this.feiraClienteDto.metros, [Validators.required]],
    });
  }


  atualizarFeiraCliente(): void {

    if (this.feiraClienteForm.invalid) {
      this.feiraClienteForm.markAllAsTouched();

      return;
    }

    const dto: FeiraClienteDto = {
      id: this.feiraClienteDto.id,
      metros: this.feiraClienteForm.value.metros,
      clienteId: this.feiraClienteDto.clienteId
    };


    this.feiraClienteService.atualizarFeiraCliente(dto)
      .subscribe({

        next: (data) => {
          this.activeModal.close(data);
          this.toastService.show("Feira atuaizada com sucesso!", {
            classname: "bg-success text-light",
          });

          setTimeout(() => {
            window.location.reload();
          }, 1500);

        }
        , error: (error) => {
          this.toastService.show("Erro ao atualizar feira!", {
            classname: "bg-danger text-light",
          });
          
          this.activeModal.dismiss(error);
        }
      });
  }
}
